<template>
  <div>
    <list
      row-key="RecordId"
      ref="list"
      unit="用户信息"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <!-- <el-form-item label="昵称">
            <el-input v-model="params.NickName" placeholder="请输入昵称" clearable />
          </el-form-item> -->
        <el-form-item label="用户类型" v-if="isDialog">
          <el-select
            v-model="params.PersonType"
            placeholder="请选择类型"
            clearable
          >
            <el-option label="企业用户" :value="1"></el-option>
            <el-option label="个人用户" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="协会会员">
          <el-select v-model="params.IsMember" placeholder="请选择" clearable>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input
            v-model="params.PersonName"
            placeholder="请输入姓名"
            clearable
          />
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input
            v-model="params.ContactPhone"
            placeholder="请输入手机号码"
            clearable
          />
        </el-form-item>
        <el-form-item label="身份证号码" v-if="false">
          <el-input
            v-model="params.PersonIdno"
            placeholder="请输入身份证号码"
            clearable
          />
        </el-form-item>
        <el-form-item label="用户等级">
          <el-select
            v-model="params.PersonGradeid"
            placeholder="请选择用户等级"
            clearable
          >
            <el-option
              v-for="(i, k) in Grades"
              :key="k"
              :label="i.GradeName"
              :value="i.RecordId"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="状态">
            <el-select v-model="params.State" placeholder="请选择状态" clearable>
              <el-option label="已实名" :value="1"></el-option>
              <el-option label="未实名" :value="0"></el-option>
            </el-select>
          </el-form-item> -->

        <el-form-item label="注册时间">
          <el-date-picker
            size="mini"
            v-model.trim="params.RegStarttime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin: 0 10px">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.RegEndtime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <!-- <el-table-column prop="NickName" label="昵称" min-width="100px"/> -->
        <el-table-column prop="PersonType" label="用户类型" min-width="100px">
          <template slot-scope="{ row }">
            <span v-if="row.PersonType == 1">企业用户</span>
            <span v-if="row.PersonType == 0">个人用户</span>
          </template>
        </el-table-column>
        <el-table-column prop="PersonName" label="姓名" min-width="100px" />
        <el-table-column prop="PersonCode" label="编号" min-width="150px" />
        <el-table-column
          prop="PersonSex"
          width="80px"
          label="性别"
          align="center"
          min-width="100px"
        >
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.PersonSex == 1">男</el-tag>
            <el-tag type="danger" v-else-if="row.PersonSex == 0">女</el-tag>
            <el-tag v-else>保密</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="ContactPhone"
          label="手机号码"
          min-width="150px"
        />
        <el-table-column
          prop="PersonIdno"
          label="身份证号码"
          min-width="150px"
        />
        <el-table-column prop="GradeName" label="用户等级" min-width="100px" />
        <el-table-column prop="IsMember" label="协会会员" min-width="100px">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.IsMember == 1">是</el-tag>
            <el-tag type="danger" v-else-if="row.IsMember == 0">否</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="PersonPoints" label="会员积分" min-width="100px"/> -->
        <!-- <el-table-column prop="PersonBalance" label="会员余额" min-width="100px"/> -->

        <!-- <el-table-column prop="State" width="80px" label="状态" align="center" min-width="100px">
            <template slot-scope="{row}">
              <el-tag type="success" v-if="row.State == 1">已实名</el-tag>
              <el-tag type="danger" v-else>未实名</el-tag>
            </template>
          </el-table-column> -->
        <el-table-column label="头像" align="center" width="145px">
          <template slot-scope="{ row }">
            <el-image
              v-if="row.ProfilePhoto"
              :src="'/api' + row.ProfilePhoto"
              style="width: 120px; margin-top: 8px"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="RegisterTime"
          label="注册时间"
          min-width="160px"
        />

        <!--       <el-table-column prop="RegisterTime" label="注册时间">
          <template slot-scope="{row}">
            {{$commonJs.toDateString(row.RegisterTime)}}
          </template>
        </el-table-column> -->
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
  <script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    isDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      api: require("@/api/person/personinfo").default,
      grade_api: require("@/api/person/persongrade").default,
      params: {
        PersonName: "",
        ContactPhone: "",
        PersonIdno: "",
        PersonGradeid: null,
        RegStarttime: null,
        RegEndtime: null,
        EndTime: null,
        State: 1,
        PersonType: null,
        IsMember: null,
      },
      Grades: [],
    };
  },
  mounted() {
    this.grade_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.Grades = res.Data;
      }
    });
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>